import React, { useEffect, useState } from "react";
import styles from "@/pages/css/CreateProjectPage.module.css";

import { CreateAlternativeRequest } from "@/types/alternative";
import { useTranslation } from "react-i18next";
import { InputField } from "@/components/inputFields/inputFields";
import SelectField from "@/components/inputFields/SelectField";

const ENERGY_RATINGS = ["A+", "A", "B", "C", "D"];
type EnergyRating = typeof ENERGY_RATINGS[number];

const DETAILED_FIELDS = ["roofs_area", "facades_area_north", "facades_area_south", "facades_area_east", "facades_area_west"];

export const CreateAlternativeFields: React.FC<{
    onChange: (data: CreateAlternativeRequest) => void;
    data: CreateAlternativeRequest;
    setStepsCompleted: React.Dispatch<React.SetStateAction<boolean>>;
    disabled: boolean;
}> = ({ onChange, data, setStepsCompleted, disabled }) => {
    const { t } = useTranslation("CreateProjectPage");
    // const [isError, setIsError] = useState(false);
    // const [hasInteracted, setHasInteracted] = useState(false);
    const [productionError, setProductionError] = useState<string>("");

    // וידוא שיש ערך דיפולטיבי ל-building_energy_rating
    useEffect(() => {
        if (!data.building_energy_rating) {
            const newData = { ...data, building_energy_rating: "B" as "B" };
            onChange(newData);
        }
    }, []);

    const titles = [
        {
            title: t("roofs_area"),
            id: "roofs_area",
            required: false,
            isEnergyField: true
        },
        {
            title: t("facades_area_north"),
            id: "facades_area_north",
            required: false,
            isEnergyField: true
        },
        {
            title: t("facades_area_south"),
            id: "facades_area_south",
            required: false,
            isEnergyField: true
        },
        {
            title: t("facades_area_east"),
            id: "facades_area_east",
            required: false,
            isEnergyField: true
        },
        {
            title: t("facades_area_west"),
            id: "facades_area_west",
            required: false,
            isEnergyField: true
        },
        {
            title: t("planned_additional_production"),
            id: "planned_additional_production",
            required: false,
        },
        {
            title: t("residents_final_target_year"),
            id: "residents_final_target_year",
            required: false
        },
        {
            title: t("residential_area_planned"),
            id: "residential_area_planned",
            required: false
        },
        {
            title: t("residental_unit_area_planned"),
            id: "residental_unit_area_planned",
            required: false
        },
        {
            title: t("commercial_area_planned"),
            id: "commercial_area_planned",
            required: false
        },
        {
            title: t("public_building_area_planned"),
            id: "public_building_area_planned",
            required: false
        },
        {
            title: t("industrial_area_planned"),
            id: "industrial_area_planned",
            required: false
        },
        {
            title: t("building_energy_rating"),
            id: "building_energy_rating",
            required: false
        },
        {
            title: t("future_residential_parking"),
            id: "future_residential_parking",
            required: false
        },
        {
            title: t("future_commercial_parking"),
            id: "future_commercial_parking",
            required: false
        },
        {
            title: t("future_industrial_parking"),
            id: "future_industrial_parking",
            required: false
        },
        {
            title: t("future_public_parking"),
            id: "future_public_parking",
            required: false
        },
    ];

    const handleChange = (field: keyof CreateAlternativeRequest, value: number | string, subField?: string) => {
        // if (!hasInteracted) {
        //     setHasInteracted(true);
        // }
        
        const newData = { ...data };
        if (subField) {
            const existingData = newData[field];
            
            if (value !== '' && value !== null && value !== undefined && !isNaN(Number(value)) && Number(value) >= 0) {
                (newData as any)[field] = {
                    ...(typeof existingData === "object" && existingData !== null ? existingData : {}),
                    [subField]: Number(value)
                };
            } else {
                if (existingData && typeof existingData === "object") {
                    const updatedData = { ...existingData };
                    delete updatedData[subField];
                    if (Object.keys(updatedData).length === 0) {
                        delete newData[field];
                    } else {
                        (newData as any)[field] = updatedData;
                    }
                }
            }
        } else {
            if (field === "building_energy_rating") {
                (newData as any)[field] = value || "B";
            } else if (value !== '' && value !== null && value !== undefined && !isNaN(Number(value)) && Number(value) >= 0) {
                const numericValue = Number(value);
                
                // בדיקה מיוחדת עבור planned_additional_production
            if (field === "planned_additional_production") {
                if (numericValue <= 0) {
                    setProductionError("הערך חייב להיות גדול מ-0");
                    return; // לא נשמור ערך שלילי או אפס
                } else {
                    setProductionError(""); // נקה שגיאה אם הערך תקין
                }
            }
                
                (newData as any)[field] = numericValue;
            } else {
                // אם מוחקים ערך מ-planned_additional_production, נקה גם את השגיאה
                if (field === "planned_additional_production") {
                    setProductionError("");
                }
                delete newData[field];
            }
        }
        
        onChange(newData as CreateAlternativeRequest);
    };


    useEffect(() => {
        setStepsCompleted(true);
    }, [data]);
    // useEffect(() => {
    //     setStepsCompleted(() => {
    //         // בדיקת שדות חובה רגילים (שלא קשורים לייצור אנרגיה)
    //         const otherRequiredFieldsFilled = titles
    //             .filter(title => title.required && !DETAILED_FIELDS.includes(title.id) && title.id !== 'planned_additional_production')
    //             .every(field => data[field.id as keyof CreateAlternativeRequest] !== undefined);

    //         // בדיקה שיש או כמות מתוכננת או כל שדות הפירוט
    //         const hasValidEnergyProduction = (data.planned_additional_production !== undefined && data.planned_additional_production !== null) || 
    //             DETAILED_FIELDS.every(field => {
    //                 const value = data[field as keyof CreateAlternativeRequest];
    //                 return value !== undefined && value !== null;
    //             });

    //         if (hasInteracted && (!hasValidEnergyProduction)) {
    //             setIsError(true);
    //         } else {
    //             setIsError(false);
    //         }

    //         return otherRequiredFieldsFilled && hasValidEnergyProduction;
    //     });
    // }, [data, hasInteracted]);

    return <div className={styles.dataContainer}>
            
            <div className={styles.inputTitle}>{t("pahse2_description")}</div>
                    {/* <span className={styles.description + (isError ? " text-red"  : "")}>בעת הזנת הנתונים יש לשים לב כי עלייך למלא כמות מתוכננת יצור עתידי סה״כ או את שדות המ״ר לגגות וחזיתות</span> */}

            <div className={styles.inputContainerOnePage}>
                
                {titles.map((title, index) => (
                    <div key={index} className={styles.titleElementComponent}>
                        <div className={styles.inputTitle}>
                            {title.required && <div className={styles.required}>*</div>}
                            {title.title}
                        </div>
                        {title.id === "building_energy_rating" ? (
                            <SelectField
                                data={ENERGY_RATINGS}
                                selectedValue={data[title.id] as EnergyRating || "B"}
                                updateFunction={(value) => handleChange(title.id as keyof CreateAlternativeRequest, value as EnergyRating)}
                                disabledState={disabled}
                                size="small"
                                showEmpty={false}
                            />
                        ) : (
                            <InputField 
                                small={true}
                                inputType="number" 
                                data={data[title.id as keyof CreateAlternativeRequest] as number} 
                                setData={(value) => handleChange(title.id as keyof CreateAlternativeRequest, Number(value))}
                                id={title.id}
                                disabled={disabled}
                                // errorMessage={
                                //     title.id === "planned_additional_production" && productionError 
                                //         ? productionError 
                                //         : (isError && title.isEnergyField ? t("field_required") : undefined)
                                // }
                                // showError={
                                //     title.id === "planned_additional_production" 
                                //         ? !!productionError 
                                //         : false
                                // }
                                errorMessage={title.id === "planned_additional_production" ? productionError || undefined : undefined}
                                showError={title.id === "planned_additional_production" && !!productionError}
                            />
                        )}
                    </div>
                ))}
            </div>
    </div>;
};